module.exports = __webpack_public_path__ + "static/media/pioneer.7625876b.jpg";